// some imports idk yet what though probably the folder and react
import React, { useEffect, useState } from 'react';
import './assets/scss/sassOutlineForFroggyGame.scss';
import alttext from './assets/json/frogtext.json';


function FroggyDressUp() {

	const items = {"bg": 30, "hat": 68, "body": 24, "acc": 36, "face": 45, "credits": -1, "color": 22};
	//const alttext = fetch("./assets/json/frogtext.json").then((res) => {return res.json()});

	const [bgState, setBgState] = useState("transparent.png");
	const [hatState, setHatState] = useState("transparent.png");
	const [bodyState, setBodyState] = useState("transparent.png");
	const [accState, setAccState] = useState("transparent.png");
	const [faceState, setFaceState] = useState("transparent.png");
	const [creditState, setCreditState] = useState("transparent.png");
	const [colorState, setColorState] = useState("color0.png");
	//const [tabState, setTabState] = useState('<img className="gridimg" src={images["bg1.png"]} onClick={() => selectbg("bg1.png")}></img>');

	function selectbg(name) {
		setBgState(name);
	}

	function selecthat(name) {
		setHatState(name);
	}

	function selectbody(name) {
		setBodyState(name);
	}

	function selectacc(name) {
		setAccState(name);
	}

	function selectface(name) {
		setFaceState(name);
	}

	function selectcredit(name) {
		setCreditState(name);
	}

	function selectcolor(name) {
		setColorState(name);
	}

	useEffect(() => { setBgState(bgState); }, [bgState]);
	useEffect(() => { setHatState(hatState); }, [hatState]);
	useEffect(() => { setBodyState(bodyState); }, [bodyState]);
	useEffect(() => { setAccState(accState); }, [accState]);
	useEffect(() => { setFaceState(faceState); }, [faceState]);
	useEffect(() => { setCreditState(creditState); }, [bgState]);
	useEffect(() => { setColorState(colorState); }, [colorState]);

	function importAll(r) {
		let images = {};
		r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
		return images;
	  }
	  
	const images = importAll(require.context('./assets/img', false, /\.(png|jpe?g|svg)$/));
	
	function makeGrid(name) {
		/*check number of elements <= 9
		 *if == 9, make grid normally, else
		 *fill as much as you can
		 setGridState("bgs0")
		 */
		//console.log(alttext);
		var codeBlock = '';
		var select = 'select' + name + '(';
		//alert(select);
		var gridBody = document.getElementById("gridBody");
		gridBody.innerHTML= '';
		for (var i = 0; i <= items[name]/*items[name]*/; i = i + 1) {
			var filename = name + String(i) + '.png';
			//var onclick = ' onclick={() => ' + select + '"' + filename + '");}'; //THIS LINE IS THE ISSUE GDI)
			//var curline = '<img id="'+ filename + '"' + onclick + ' className="gridimg"' + ' src=' + images[filename] + '></img>';
			//alert(curline);
			//codeBlock += curline;
			//alert(filename);
			var gridImg = document.createElement("div");
			gridImg.className = "gridelem";

			var placeholderFrog = document.createElement("img");
			var newImage = document.createElement("img");
			newImage.className = "gridimg";
			newImage.setAttribute("id", filename);
			//newImage.setAttribute("onClick", '() => ' + select + '"' + filename + '")');
			newImage.setAttribute("src", images[filename]);
			if ((i == 0 && name !== "credit" && name !== "color")) { filename = 'transparent.png'; } else {
				/*if (name == "bg") { 
					placeholderFrog.className = "placeholderFrogForBg"; 
					//(function(localFilename) {placeholderFrog.addEventListener("click", function() {  selectbg(localFilename); }); })(filename) 
				} else {
					placeholderFrog.className = "placeholderFrog";
				}*/
				placeholderFrog.className = name == "bg" ? "placeholderFrogForBg" : "placeholderFrog";
				placeholderFrog.setAttribute("src", images['ghostFrog.png']);
			}

			var overlay = document.createElement("img");
			overlay.setAttribute("id", "overlay");
			overlay.setAttribute("src", images["border_large.png"]);
			//console.log(alttext["alttext"][0]["bg0"]);
			//console.log(name + String(i));
			var pos = name + String(i);
			overlay.alt = alttext["alttext"][0][pos];



			switch (name) {
				case "bg":
					(function(localFilename) { overlay.addEventListener("click", function() {  selectbg(localFilename); }); })(filename)
					break;
				case 'hat':
					(function(localFilename) { overlay.addEventListener("click", function() {  selecthat(localFilename); }); })(filename)
					break;
				case 'body':
					(function(localFilename) { overlay.addEventListener("click", function() {  selectbody(localFilename); }); })(filename)
					break;
				case 'acc':
					(function(localFilename) { overlay.addEventListener("click", function() {  selectacc(localFilename); }); })(filename)
					break;
				case 'face':
					(function(localFilename) { overlay.addEventListener("click", function() {  selectface(localFilename); }); })(filename)
					break;
				case 'credit':
					(function(localFilename) { overlay.addEventListener("click", function() {  selectcredit(localFilename); }); })(filename)
					break;
				case 'color':
					(function(localFilename) { overlay.addEventListener("click", function() {  selectcolor(localFilename); }); })(filename)
					break;
			}

			gridImg.appendChild(placeholderFrog);
			gridImg.appendChild(newImage);
			gridImg.appendChild(overlay);
			gridBody.append(gridImg);
		}
	}
	
	function selectTab(name) {
		/*when the user clicks a tab, we use this function
		 *to switch to the 0th tab of that category
		 *would look something like:
		 setGridState(name);
		 */
		//alert("you selected " + name);
		makeGrid(name);
	}

	function deleteParent(button) {
		button.parentElement.remove();
		//console.log(button.parentElement);
	}

	function back() {
		var coverup = document.getElementById("coverup");
		coverup.remove();
	}

	function prepareSave() {
		var pageBg = document.createElement("div");
		pageBg.className = "coverup";
		pageBg.setAttribute("id", "coverup");

		var backButton = document.createElement("button");
		backButton.className = "bigButton";
		backButton.setAttribute("id", "BACKButton");
		backButton.addEventListener("click", back);
		backButton.setAttribute("aria-label", "Back button");

		var pNode = document.createElement("p");
		//pNode.className = "bigText";
		//var text = document.createTextNode("BACK");

		//pNode.appendChild(text);
		backButton.appendChild(pNode);
		pageBg.appendChild(backButton);

		var main = document.getElementById("FroggyDressUp");
		main.append(pageBg);
		
	}
	
	function saveImage() {
		/*idk how this would work, will need to be googled
		 *but i feel like it's important
		 saveToUserComputerWhichWeDefinitelyHaveAccessTo(); 
		 */
		prepareSave();
		var x = 510

		var canvas = document.createElement("canvas");
		canvas.setAttribute("id", "finalFrogge");
		if (! canvas || ! canvas.getContext) { return false; }
		canvas.width = 510;
		canvas.height = 510;
		var ctx = canvas.getContext('2d');
		ctx.imageSmoothingEnabled = false;
		var frogBg = new Image();
		var frogBase = new Image();
		var frogFace = new Image();
		var frogBody = new Image();
		var frogHat = new Image();
		var frogAcc = new Image();
		frogBg.src = images[bgState];
		frogBase.src = images[colorState];
		frogFace.src = images[faceState];
		frogBody.src = images[bodyState];
		frogHat.src = images[hatState];
		frogAcc.src = images[accState];

		var bgAlt = bgState.split(".")[0];
		var colorAlt = colorState.split(".")[0];
		var faceAlt = faceState.split(".")[0];
		var bodyAlt = bodyState.split(".")[0];
		var hatAlt = hatState.split(".")[0];
		var accAlt = accState.split(".")[0];

		var bgAltText = String(alttext["alttext"][0][bgAlt]);
		var colorAltText = String(alttext["alttext"][0][colorAlt]);
		var faceAltText = String(alttext["alttext"][0][faceAlt]);
		var bodyAltText = String(alttext["alttext"][0][bodyAlt]);
		var hatAltText = String(alttext["alttext"][0][hatAlt]);
		var accAltText = String(alttext["alttext"][0][accAlt]);



		var bgAltTextFinal = bgAltText.includes("Remove") ? "transparent" : bgAltText;
		var colorAltTextFinal = colorAltText;
		var faceAltTextFinal = faceAltText.includes("Remove") ? "blank" : faceAltText;
		var bodyAltTextFinal = bodyAltText.includes("Remove") ? "nothing" : bodyAltText;
		var hatAltTextFinal = hatAltText.includes("Remove") ? "nothing" : hatAltText;
		var accAltTextFinal = accAltText.includes("Remove") ? "nothing" : accAltText;

		var canvasAlt = "Your finished froggy! It has a " + bgAltTextFinal + " background, its base color is " + colorAltTextFinal 
							+ ", and its face is " + faceAltTextFinal + ". It is wearing " + bodyAltTextFinal + " on its body, and " + hatAltTextFinal 
							 + " on its head. As an accessory, it has " + accAltTextFinal + ".";
		frogBg.onload = function() {
			ctx.drawImage(frogBg, 0, 0, x, x);
		}
		frogBase.onload = function() {
			ctx.drawImage(frogBase, 0, 0, x, x);
		}
		frogFace.onload = function() {
			ctx.drawImage(frogFace, 0, 0, x, x);
		}
		frogBody.onload = function() {
			ctx.drawImage(frogBody, 0, 0, x, x);
		}
		frogHat.onload = function() {
			ctx.drawImage(frogHat, 0, 0, x, x); 
		}
		frogAcc.onload = function() {
			ctx.drawImage(frogAcc, 0, 0, x, x);
		}
		canvas.setAttribute("aria-label", canvasAlt);
		canvas.role = "img";
		var base = document.getElementById("coverup");
		base.appendChild(canvas);
	}

	function resetImage() {
		setBgState("transparent.png");
		setHatState("transparent.png");
		setFaceState("transparent.png");
		setBodyState("transparent.png");
		setAccState("transparent.png");
		setColorState("color0.png");
	}


	function getCredits() {
		var gridBody = document.getElementById("gridBody");
		var creditText = document.createElement("p");
		creditText.className = "creditText";
		var creditText = document.createElement("p");
		creditText.className = "creditText";

		var credits = ["You can find the contributors below on various social media sites!",
		"",
		"artists:", 
		"@cloudtrumpets",
		"@DaAllygator",
		"@illufinch",
		"@iyfias",
		"@jdzombi_",
		"@juliagoodish",
		"@Knightsundere",
		"@runekitty_",
		"@silkanide",
		"@SplishyPlash",
		"",
		"coders:",
		"@logthatdata",
		"@kredgons"]
		gridBody.innerHTML = '';
		for(var i = 0; i < credits.length; i++) {
			
			var textNode = document.createTextNode(credits[i]);
			creditText.appendChild(textNode);
			var br = document.createElement("br");
			creditText.appendChild(br);
			
		}

		//creditText.appendChild(textNode);
		gridBody.appendChild(creditText);
		
	}
	//todo, add meaningful alt text?
	/* this has id background in the tutorial but idk if that's strictly necessary */
	//<img className="gridimg" src={images['bg1.png']} onClick={() => selectbg("bg1.png")}></img>
					//<button className="bigButton" id="SAVEButton" onClick={() => saveImage()}><img id="saveIcon" src={images['savebutton.png']}/></button>
				//<button className="bigButton" id="RESETButton" onClick={() => resetImage()}><img id="resetIcon" src={images['resetbutton.png']}/></button>

	return (
		//here comes the html,

		<div id="FroggyDressUp">
							<a href="https://frogpon.art"><button className="homeButton" id="HOMEButton"><p className="homeText">HOME</p></button></a>

			<div className="frogTop"></div>
			<div className="frogMiddle" aria-description="a pixelated face with two big black eyes frames two big panels, one with a frog and buttons for accessing the different types of clothing options for the frog, and the other with a grid of options for the frog. Until a category is selected, the grid is empty. Above the two frames are a save and reset button.">
				<button aria-label="Save button" className="bigButton" id="SAVEButton" onClick={() => saveImage()}/>
				<button aria-label="Reset button" className="bigButton" id="RESETButton" onClick={() => resetImage()}/>

				<div id="frogContainer">
					<div id="frog"> 
						<div id="frogbody">
							<img className="frogBg" src={images[bgState]}/>
							<img className="frogBase" src={images[colorState]}/>
							<img className="frogHat" src={images[hatState]}/>
							<img className="frogBody" src={images[bodyState]}/>
							<img className="frogFace" src={images[faceState]}/>
							<img className="frogAcc" src={images[accState]}/>
							<img className="border" src={images['transparent.png']}/>
						</div>
						<button className="options" id="COLORButton" onClick={() => selectTab("color")}><img id="colorIcon" src={images['colorIcon.png']}/></button>
						<button className="options" id="BGButton" onClick={() => selectTab("bg")}><p className="topdown">BG</p></button>
						<button className="options" id="HATButton" onClick={() => selectTab("hat")}><p className="topdown">HAT</p></button>
						<button className="options" id="BODYButton" onClick={() => selectTab("body")}><p className="topdown">BODY</p></button>
						<button className="options" id="ACCButton" onClick={() => selectTab("acc")}><p className="topdown">ACC</p></button>
						<button className="options" id="FACEButton" onClick={() => selectTab("face")}><p className="topdown">FACE</p></button>
						<button className="options" id="CButton" onClick={() => getCredits()}><p className="topdown">C</p></button>
		
					</div>
		
					
				
					<div id="optionContainer">
						<div id="grid">
							<div id="gridBody">
							</div>
						</div>
					</div> 
				</div>
			</div>
			<div className="frogBottom"></div>
			
			
			
			
		</div>
	);
}
	
export default FroggyDressUp